"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Flex = _interopRequireDefault(require("./Flex"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* 
 * Renders a breadcrumb
 */const Breadcrumb = props => {
  const handleClick = () => props.onClick(props.item?.Id);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
    columnar: true,
    onClick: handleClick,
    children: [props.icon, props.item?.Name]
  });
};
var _default = exports.default = Breadcrumb;